import React, { Component } from "react";

import PageSpinner from "../PageSpinner";
import Banner from "../common/banner";
import SearchNoteForm from "./searchordernote"
import NoteGrid from '../../components/common/notesgrid'
import OrderNoteForm from "./OrderNoteForm"
import axios from 'axios';
import appConfig from '../../config/config';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import MTSApi from '../../API/mtsapi'
const colHeader = [
    { dataField: 'ID', text: 'Sr No' },
    { dataField: 'NOTE', text: 'Note' },
    { dataField: 'CREATEDUSERNAME', text: 'User' },
    { dataField: 'CREATEDDATE', text: 'Date' },

];
var dataColumns = colHeader.map(function (d) { return { dataField: d.dataField, text: d.text, sort: true } });

class OrderNotePage extends Component {
    constructor(props) {
        super(props);
    }
    complete=(response)=> {
        this.setState({ ...this.state, data: response, Loading: false, complete: true });
    }
    loading = (isLoading) => {
        this.setState({ ...this.state, Loading: isLoading, row:null });
    }
    state = { Loading: false, searchCount: 0, data: [], complete:false, addrow : false }

    loadNotes() {
        this.loading(true);
        axios.post(
            appConfig.apiGateway.searchOrderUrl,
            JSON.stringify({ OrderProductId: this.props.OrderProductId, Action: "OrderNote" }),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.loading(false);
            this.complete(JSON.parse(response.data.body));
        }, error => {
            this.loading(false);
        });
    }
    componentDidMount(){
        this.loadNotes();
    }
    closeBanner =() =>{
        this.setState({ ...this.state, showBanner:false, message:'' });
    }
    Add = ( toggle)=> {
        this.loadNotes();
        this.setState({ ...this.state, addrow:toggle });
    }
    Edit = ( row)=> {
        this.setState({ ...this.state, row:row });
    }
    showBanner =(show,message) => {
        this.setState({ ...this.state, showBanner:show, message });
    }
    render() {
        return (
            <>
            {this.state.showBanner && (<Banner Close={this.closeBanner} message={this.state.message} IsSuccess={true}/>)}
                <SearchNoteForm complete={this.complete} loading={this.loading} OrderProductId={this.props.OrderProductId} Add={this.Add}/>
                {(this.state.Loading == true) && (< PageSpinner />)}
                
                {(this.state.complete == true) && (<NoteGrid 
                    data={this.state.data} 
                    OrderColumns={dataColumns} 
                    setSelectedRow={this.Edit}
                    />)}
                {(this.state.addrow ) && (<OrderNoteForm Add={this.Add} isOpen={this.state.addrow} 
                    OrderId={this.props.OrderId} OrderProductId={this.props.OrderProductId} showBanner={this.showBanner}/>)}
            </>
        );
    }

}



const mapStatetoProps = state => {
    return { session: state.session }
}
var orderNotePage = reduxForm({
    form: 'orderNotePage'
})(OrderNotePage);
orderNotePage = connect(mapStatetoProps)(orderNotePage);
 export default orderNotePage;